// Global imports
import { clsx } from 'clsx'
import { NumberedCard, Slider } from '~/components'

// Types
import type { NumberedCardItem, NumberedCardMobileView } from '~/types'

interface Props {
  cards: NumberedCardItem[]
  mobileView: NumberedCardMobileView
  outlined?: boolean
  onDark?: boolean
}

// Main export
const NumberedCardGrid = ({
  cards,
  mobileView,
  outlined = false,
  onDark = false,
}: Props) => {
  const items = cards.map((card, i) => (
    <NumberedCard
      key={i}
      {...card}
      number={i + 1}
      outlined={outlined}
    />
  ))

  // A single card has nothing to swipe to, so it always stacks
  const isCarousel = mobileView === 'carousel' && cards.length > 1

  // On phones the cards either stack or swipe as a carousel, with the next
  // card peeking in, as set in the Studio. From tablet width up they are
  // always a grid, so the carousel is only drawn below that and the grid only
  // above it. The carousel shares the product carousel's slider-products
  // class, which lets every slide stretch to the tallest card so the cards
  // match in height
  return (
    <>
      {isCarousel && (
        <div className="pb-8 md:hidden">
          <Slider
            className="slider-products w-full"
            dotsColour={onDark ? 'light' : 'dark'}
            options={{ gap: '1rem', padding: { right: '3rem' } }}
          >
            {items}
          </Slider>
        </div>
      )}
      <div
        className={clsx('grid-cols-1 gap-6 md:grid-cols-2', {
          grid: !isCarousel,
          'hidden md:grid': isCarousel,
          'lg:grid-cols-3': cards.length === 3,
          'lg:grid-cols-4': cards.length >= 4,
        })}
      >
        {items}
      </div>
    </>
  )
}

export default NumberedCardGrid
